import { render, staticRenderFns } from "./ConfigAlertTelegram.vue?vue&type=template&id=aacff264&"
import script from "./ConfigAlertTelegram.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports